import * as config from "Config";
import * as constants from "./constants";


export function clearStore(newObject) {
    return {
      type: constants.COMPANY_LIST_CLEAR_STORE
    };
}

export function initCompanyListData() {
    return {
      remote:{
          method: "get",
          url: config.apiUrl + "/api/Company/Summury"
      },
      actions: [
          constants.COMPANY_LIST_SUMMURY_LOAD_START,
          constants.COMPANY_LIST_SUMMURY_LOAD_SUCCESS,
          constants.COMPANY_LIST_SUMMURY_LOAD_FAIL,
      ]
    };
}

export function deleteCompany(id) {
    return {
      remote:{
          method: "delete",
          url: config.apiUrl + "/api/Company/"+id
      },
      actions: [
          constants.COMPANY_LIST_REMOVE_START,
          constants.COMPANY_LIST_REMOVE_SUCCESS,
          constants.COMPANY_LIST_REMOVE_FAIL,
      ]
    };
}
